const toggleElement = (element, isVisible) => {
  if (isVisible) {
    element.classList.remove('d-none');
  } else {
    element.classList.add('d-none');
  }
};

export default toggleElement;
